var React = require('react');

function Deltai (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#ED2246"},React.createElement("path",{"d":"M89.267 84.944L79.5 72.868l-9.766 12.076c-1.338-1.382-2.385-3.046-3.042-4.893L79.5 64.17l12.832 15.816c-.657 1.873-1.713 3.56-3.065 4.958m-18.114 1.278L79.5 75.9l8.347 10.322c-2.306 1.798-5.203 2.871-8.347 2.871-3.144 0-6.042-1.073-8.347-2.871m7.712-24.3L66.09 77.72c-.12-.723-.182-1.465-.182-2.222 0-7.282 5.756-13.245 12.958-13.577m14.228 13.577c0 .757-.063 1.499-.182 2.222l-12.776-15.8c7.201.333 12.958 6.296 12.958 13.578M79.5 60C70.954 60 64 66.953 64 75.5S70.954 91 79.5 91C88.047 91 95 84.047 95 75.5S88.047 60 79.5 60","transform":"translate(-64 -60)"}))));
}

Deltai.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31"};

module.exports = Deltai;

Deltai.default = Deltai;
